<template>
  <div class="user_container">
    <div class="driverContainer">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="driverItems" v-for="(item, index) in list" :key="index">
          <div class="itemsContent">
            <div @click="useCarDetail(item)">
              <div class="itemsUser">
                <div class="userTitle">{{ item.applyTitle }}</div>
                <div class="tabsList">
                  <div class="tabBtn colorYellow">
                    <span class="btn">{{
                      useTypeList[item.useType - 1]
                    }}</span>
                  </div>
                  <div class="tabBtn" :class="item.useState === 1
                        ? 'colorBlue'
                        : item.useState === 2
                          ? 'colorGreen'
                          : ''
                      ">
                    <span class="btn">{{
                      item.useState === 1
                      ? "未开始"
                      : item.useState === 2
                        ? "使用中"
                        : ""
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="itemsPlace">
                <div class="allotPlaceItems">
                  <div class="place">{{ item.airportName }}</div>
                </div>
                <div class="line">
                  <img src="@/assets/car/placeArrows.png" alt="" />
                </div>
                <div class="allotPlaceItems1">
                  <div class="place" v-for="(i, int) in item.addressInfoList" :key="int">{{ i.useLocation }}</div>
                </div>
              </div>
              <div class="itemsInfo">
                <div class="info">人数：{{ item.useNumber }}</div>
              </div>
              <div class="itemsInfo">
                <div class="info">
                  用车时间：<span style="font-size: 13px">{{
                    item.useSaterTime + "-" + item.useEndTime
                  }}</span>
                </div>
              </div>
              <div class="itemsInfo">
                <div class="info">联系人：{{ item.useName }}</div>
              </div>
              <div class="itemsInfo">
                <div class="info">联系方式：{{ item.usePhone }}</div>
              </div>
              <div class="itemsHeader">
                <div class="headerContent">
                  <img class="userName" :src="item.icon" alt="" />
                  <span>{{ item.driverName }}</span>
                </div>
                <div class="headerContent">
                  <img class="car" src="@/assets/car/carAllot.png" alt="" />
                  <span class="carTitle">{{ item.carBrand }}</span>
                </div>
              </div>
            </div>
            <div class="splitLine"></div>
            <div class="itemsBtn">
              <van-button :class="item.useState === 1
                ? 'bgColor'
                : item.useState === 2
                  ? 'greenColor'
                  : ''
                " type="default" size="small" @click="comfirmOff(item)">{{
    item.useState === 1
    ? "确认出发"
    : item.useState === 2
      ? "结束行程"
      : "确认出发"
  }}</van-button>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div>
      <van-popup v-model="showComfirmOff" position="bottom" :style="{ height: '50%' }">
        <div style="padding: 20px">
          <van-form ref="form">
            <van-field type="number" v-model="form.startMileage" label="开始公里数" name="startMileage" placeholder="请输入开始公里数"
              v-if="formKey === '1'" required :rules="[
                {
                  trigger: 'onBlur',
                  required: true,
                  message: '请输入开始公里数'
                }
              ]" />
            <van-field v-model="endForm.endMileage" type="number" v-if="formKey !== '1'" label="结束公里数" name="endMileage"
              required placeholder="请输入结束公里数" :rules="[
                {
                  trigger: 'onBlur',
                  required: true,
                  message: '请输入结束公里数'
                }
              ]" />
            <van-field v-model="endForm.roadBridgeCost" label="路桥费" type="number" placeholder="请输入路桥费"
              v-if="formKey !== '1'" />
            <van-field v-model="endForm.otherCost" label="其他费用" type="number" placeholder="请输入其他费用"
              v-if="formKey !== '1'" />
            <van-field v-model="form.remarks" rows="2" autosize label="备注" type="textarea" placeholder="若有特殊情况请备注" />
            <div class="peopleBtn">
              <van-button @click="cancelOff" type="default" size="small" native-type="button">取消</van-button>
              <van-button class="confirm" size="small" @click="submitOff" :style="{
                background:
                  formKey === '1'
                    ? '#2C76E3'
                    : formKey === '2'
                      ? '#4EA27C'
                      : '#2C76E3'
              }">{{
  formKey === "1"
  ? "确认出发"
  : formKey === "2"
    ? "结束行程"
    : "确认出发"
}}</van-button>
            </div>
          </van-form>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/car.js";
import moment from "moment";
import "moment/locale/zh-cn";
import "@/assets/car/icon/iconfont.css";
export default {
  name: "driverRoute",
  props: {},
  components: {},
  data() {
    return {
      showComfirmOff: false,
      showEndRoute: false,
      formKey: "",
      form: {
        startMileage: "",
        remarks: "每小时40公里起，不满40公里按40公里计算，计时一天8小时封顶。若一天（用车以公司出发为准，不超24小时按一天计算）公里数超过8*40=320公里按实际发生公里数计算。"
      },
      endForm: {
        endMileage: "",
        roadBridgeCost: "",
        otherCost: ""
      },
      driverInfo: {},
      applyNumber: "",
      page: 1,
      pageSize: 20,
      totalAll: 0,
      loading: false,
      finished: false,
      list: [],
      startMileage: "",//开始里程数
      id: '',
      useTypeList: ["客户接待", "接机", '送机', "供应商考察", "其他"],
    };
  },
  created() {
    //获取司机信息
    this.driverInfo = JSON.parse(localStorage.getItem("store")).userInfo;
  },
  mounted() { },
  methods: {
    onLoad() {
      this.getToDoList();
    },
    //跳转用车详情&费用详情
    useCarDetail(item) {
      this.$router.push({
        path: "/car/official/applyDetail",
        query: {
          applyNumber: item.applyNumber, //newlyAdded modify
        }
      });
    },
    //获取待办列表
    getToDoList() {
      const { type } = this.$route.query
      const json = {
        page: this.page,
        pageSize: this.pageSize,
        driverCode: type == 2 ? '' : this.$store.state.userInfo.username,
      };
      if(type){
        json.type = type
      }
      apis.queryToDoList(json).then(res => {
        if (res.code === 200) {
          this.totalAll = res.data.total;
          this.finished = false;
          //判断分页，下滑加载数据
          if (this.page === 1) {
            this.list = res.data.list;
          } else {
            this.list = this.list.concat(res.data.list);
          }
          if (this.list.length < this.totalAll) {
            this.page = this.page + 1;
          } else {
            this.finished = true;
          }
          this.loading = false;
          //将时间戳转换为日期格式
          this.list = this.list.map(item => {
            item.useSaterTime = moment(item.useSaterTime).format(
              "YYYY-MM-DD HH:mm"
            );
            item.useEndTime = moment(item.useEndTime).format(
              "YYYY-MM-DD HH:mm"
            );
            return item;
          });
        }
      });
    },
    //确认出发&结束行程
    comfirmOff(item) {
      this.form = {};
      this.form.remarks = '每小时40公里起，不满40公里按40公里计算，计时一天8小时封顶。若一天（用车以公司出发为准，不超24小时按一天计算）公里数超过8*40=320公里按实际发生公里数计算。';
      this.endForm = {};
      this.startMileage = item.startMileage;
      this.applyNumber = item.applyNumber;
      this.formKey = item.useState === 2 ? "2" : "1";
      this.showComfirmOff = true;
      this.id = item.id;
    },
    //取消出发
    cancelOff() {
      this.$refs.form.resetValidation();
      this.showComfirmOff = false;
      this.form = {};
      this.endForm = {};
    },
    // 确认出发
    submitOff() {
      this.$refs.form.validate().then(() => {
        if (this.formKey === "1") {

          const json = {
            ...this.form,
            applyNumber: this.applyNumber
          };
          apis.insertCarCost(json).then(res => {
            if (res.code === 200) {
              this.onLoad();
              this.showComfirmOff = false;
              this.$toast.success("已确认出发");
            }
          });
        } else if (this.formKey === "2") {
          if (Number(this.startMileage) >= Number(this.endForm.endMileage)) {
            return this.$toast("开始里程数不能大于等于结束里程数");
          }
          const json = {
            ...this.endForm,
            remarks: this.form.remarks,
            applyNumber: this.applyNumber,
            startMileage: this.startMileage,
            id: this.id
          };
          apis.updateCarCost(json).then(res => {
            if (res.code === 200) {
              this.onLoad();
              this.showComfirmOff = false;
              this.$toast.success("已结束行程");
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}

.user_container {
  margin: auto;
  font-size: 16px * $zoom;

  .driverContainer {
    padding: 30px;

    &::-webkit-scrollbar {
      display: none;
    }

    .driverItems {
      margin-bottom: 20px;
      background-color: #fff;

      .itemsHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;

        // padding: 10px;
        .headerContent {
          font-size: 27px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #282b32;
          display: flex;
          align-items: center;

          .userName {
            width: 53px;
            height: 53px;
            border-radius: 50%;
            margin-right: 11px;
          }

          .car {
            width: 36px;
            height: 27px;
            margin-right: 11px;
          }

          .carTitle {
            font-weight: bold;
          }
        }
      }

      .itemsContent {
        padding: 0 20px 25px 20px;

        .itemsUser {
          display: flex;
          flex-direction: column;
          margin: 0 0 4vh 0;

          .userTitle {
            font-size: 27px;
            font-family: PingFang-SC-Bold, PingFang-SC;
            font-weight: bold;
            color: #282b32;
            margin-right: 20px;
            padding-top: 36px;
          }

          .tabsList {
            display: flex;

            .tabBtn {
              min-width: 106px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              border-radius: 6px;
              padding: 0 10px;
              margin-top: 36px;
              margin-right: 20px;
              font-size: 22px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
            }

            .colorYellow {
              background-color: #fff3e8;
              color: #ff8e20;
            }

            .colorBlue {
              background-color: #e9f1fc;
              color: #2c76e3;
            }

            .colorGreen {
              background-color: #edf5f2;
              color: #4ea27c;
            }
          }
        }

        .itemsPlace {
          display: flex;
          align-items: center;
          font-size: 24px;

          .line {
            width: 50px;
            height: 7px;
            display: flex;
            align-items: center;
            margin: 0 18px;

            img {
              width: 50px;
              height: 7px;
            }
          }

          .allotPlaceItems {
            min-width: 23%;
            max-width: 29%;

            .place {
              max-width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              font-size: 23px;
              // font-weight: bold;
              color: #4ea27c;
            }
          }

          .allotPlaceItems1 {
            min-width: 23%;
            max-width: 87%;

            .place {
              max-width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              font-size: 23px;
              // font-weight: bold;
              color: #4ea27c;
            }
          }
        }

        .itemsInfo {
          margin: 2vh 0;
          font-size: 24px;
          color: #a3a2a0;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #282b32;
        }

        .splitLine {
          width: 100%;
          height: 1px;
          border: 1px solid #f1f1f1;
          margin: 37px 0;
        }

        .itemsBtn {
          text-align: right;

          ::v-deep(.van-button--small) {
            border-radius: 10px;
            height: 50px;
            padding: 0 30px;
            background-color: #4ea27c;
            font-size: 27px;
            color: #fff;
          }

          .bgColor {
            background-color: #2c76e3;
          }

          .greenColor {
            background-color: #4ea27c;
          }
        }
      }
    }
  }

  ::v-deep(.van-form) {
    .van-cell {
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
    }

    .van-field__value {
      border: 1px solid #cccccc;
      padding: 20px;
    }

    .van-cell::after {
      content: "";
      border-bottom: 0;
    }
  }

  .peopleBtn {
    margin-top: 30px;
    display: flex;
    justify-content: space-around;

    ::v-deep .van-button--small {
      height: 86px;
      width: 242px;
      font-size: 28px;
    }

    .confirm {
      background-color: #4ea27c;
      color: #fff;
    }
  }
}
</style>
